import { WishlistSchema } from "@apps/wishlist/schemas/WishlistSchema";
import { object } from "superstruct";

export const UpdateWishlistResponseSchema = object({
    updatedWishlist: WishlistSchema,
});
